import { Component, OnInit } from '@angular/core';
import { Customer, ProgramService } from '@app/program/program.service';
import { Program } from '@app/program/types';
import { FitConfigProviderService } from '@shared/fit-config-provider.service';
import { NotificationsService } from '@shared/notifications.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProgramTailorMadeService } from '../../../program-tailor-made/program-tailor-made.service';

@Component({
    selector: 'app-assign-modal',
    templateUrl: './assign-modal.component.html',
    styleUrls: ['./assign-modal.component.scss'],
    standalone: false
})

export class AssignModalComponent implements OnInit {

    constructor(
        private bsModalRef: BsModalRef,
        private notifications: NotificationsService,
        private programService: ProgramService,
        private tailorService: ProgramTailorMadeService,
        private fitConfig: FitConfigProviderService) { }

    get enablePaidProgramAssignment() {
        return this.fitConfig.enablePaidProgramAssignment;
    }

    get canAssign(): boolean {
        if (this.freeProgram || !this.enablePaidProgramAssignment) {
            return true;
        }
        return this.price != null && !!this.currencyCode;
    }

    ngOnInit() {
        if (!this.enablePaidProgramAssignment) {
            this.freeProgram = true;
        }
    }

    public program: Program;
    public user: Customer;

    public price: number;
    public currencyCode: string;

    public freeProgram = false;

    public currencyList: string[] = ['USD', 'EUR', 'GBP'];

    public async onFormSubmit() {;
        if (!this.program.is_published) {
            return this.notifications.error('Error', `Program must be published first`);
        }
        if(this.freeProgram){
            return this.assignAsFreeProgram();
        }
        const { data, error } =
            await this.tailorService.assignTailorProgramToUser(this.program.id, this.user.id, this.price, this.currencyCode);
        if (!error) {
            this.bsModalRef.hide();
            this.notifications.success('Success', `${this.user.email} will now receive payment link`);
        } else {
            this.notifications.error('Error', `${error}`);
        }
    }

    public async assignAsFreeProgram(){
        const { data, error } = await this.programService.assignProgramToUser(this.program.id, this.user.id)
        if(!error){
            this.notifications.success('Success', `Tailor made program assigned`);
            this.bsModalRef.hide();
        }
    }

    public onModalClose() {
        this.bsModalRef.hide();
    }
}
